export default class GenericIdValue {
    constructor(name, initialValue, namespace) {
      this.namespace=namespace;
      this.name=name;
      this.id="@id";
      this.value="";
      if (initialValue) {
        this.parseInputJSON(initialValue);
      }
    }

    getNameSpace() {
      return this.namespace;
    }

    getValue() {
      return this.value;
    }

    setValue(value) {
      this.value=value;
    }

    getExpandedFormatValue() {
      return [{[this.id]: this.getValue()}];
    }

    isEmpty() {
      return !this.value;
    }

    parseInputJSON(inputJSON) {
      if (!inputJSON||!inputJSON[this.namespace]) {
        return;
      }
      const val=inputJSON[this.namespace][0];
      this.setValue(val[this.id]);
    }

    print() {
      console.log(this.namespace+", "+this.id+", "+this.value);
    }
  }
